import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.companyCatalog || initialState;

export const selectCompanyDetails = createSelector(
  [selectDomain],
  (state) => state.companyDetails
);

export const selectCatalog = createSelector(
  [selectDomain],
  (state) => state.catalog
);

export const selectCommodityCategories = createSelector(
  [selectDomain],
  (state) => state.commodityCategories
);

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectTestCategories = createSelector(
  [selectDomain],
  (state) => state.testCategories
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectTestCount = createSelector(
  [selectDomain],
  (state) => state.testCount
);
